/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export interface IFieldWrapperProps {
	type: string;
	className?: string;
	grow?: boolean;
	isFocused?: boolean;
	wrapperRef?: React.MutableRefObject<HTMLDivElement>;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const FieldWrapper: FC<IFieldWrapperProps> = ({
	type,
	className,
	grow,
	isFocused,
	children,
	onClick,
	wrapperRef
}) => {
	const baseClass = BEM("edt-field", null, {
		grow: grow
	});

	baseClass.mod("type-" + type);
	baseClass.add("edt-field-element");
	baseClass.add("edt-field-element--input");

	if (isFocused) {
		baseClass.add("edt-field-element--is-focused");
	}

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()} ref={wrapperRef} onClick={onClick}>
			{children}
		</div>
	);
};
